import { createReducer, AnyAction } from '@reduxjs/toolkit';
import { ESessionActionType } from './actions';
import { IDossierV2 } from '../../models/DossierV2';
import { DossierMemberInterface } from '../../models/DossierMember';
import { SingleUser } from '../../api/types';

export interface ISessionAppState {
  dossier?: IDossierV2;
  relation?: DossierMemberInterface;
  dossierRelations?: DossierMemberInterface[];
  user?: SingleUser;
  isMultiDossierUser: boolean;
}

const initialState: ISessionAppState = {
  isMultiDossierUser: false,
};

export const sessionReducer = createReducer(initialState, {
  [ESessionActionType.SET_DOSSIER]: (state: ISessionAppState, action: AnyAction): ISessionAppState => {
    const { dossier, relation, dossierRelations } = action.payload as { dossier: IDossierV2, relation?: DossierMemberInterface, dossierRelations?: DossierMemberInterface[] };
    return { ...state, dossier, relation, dossierRelations };
  },
  [ESessionActionType.CLEAR_DOSSIER]: (state: ISessionAppState) => ({ ...state, dossier: undefined, relation: undefined, dossierRelations: undefined }),
  [ESessionActionType.SET_USER]: (state: ISessionAppState, action: AnyAction): ISessionAppState => {
    const user = action.payload as SingleUser;
    return { ...state, user };
  },
  [ESessionActionType.CLEAR_USER]: (state: ISessionAppState) => ({ ...state, user: undefined }),
  [ESessionActionType.SET_MULTI_DOSSIER_USER]: (state: ISessionAppState, action: AnyAction) => ({ ...state, isMultiDossierUser: action.payload as boolean }),
});
